module.exports = __webpack_public_path__ + "a4210c3b52072665b8567eca2695c8ed.MP3";